import { render, staticRenderFns } from "./TransferenciaPosseAbas.vue?vue&type=template&id=3218fa2c&"
import script from "./TransferenciaPosseAbas.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseAbas.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPosseAbas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/TransferenciaPosseAbas.vue
// module id = 1563
// module chunks = 28